<template>
  <div class="box12 wrap" v-loading="loading"  element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="register row">
      <div class="col-xs-12 col-md-12">
        <headerss></headerss>
        <breadcrumb></breadcrumb>
        <div class="list">
          <div class="title">
            <p>近期开班</p>
          </div>
          <el-descriptions v-for="(value, key) in classlist" v-bind:key="key"
            :title="value.name"
            :column="contentStyleObj.width > 768 ? 2 : 1"
            class="bjlb"
          >
            <el-descriptions-item label="开班时间"
              >{{value.classStartTime | dateFormat}}</el-descriptions-item
            >
            <el-descriptions-item label="结束时间"
              >{{value.classEndTime | dateFormat}}</el-descriptions-item
            >
            <el-descriptions-item label="报名开始时间"
              >{{value.signstarttime | dateFormat}}</el-descriptions-item
            >
            <el-descriptions-item label="报名结束时间"
              >{{value.signendtime | dateFormat}}</el-descriptions-item
            >
            <template slot="extra">
              <el-button class="baoming" type="primary" size="small" @click="baoming(key)"
                >报名</el-button
              >
            </template>
          </el-descriptions>
         
        </div>
        <footerss></footerss>
      </div>
    </div>
  </div>
</template>
<script>
import headerss from "../components/headerss";
import footerss from "../components/footerss";
import breadcrumb from "../components/breadcrumb";
import { GetrecentlyClass,PostsignUpClass } from "@/request/api";

export default {
  components: {
    headerss,
    footerss,
    breadcrumb,
  },
  data() {
    return {
      contentStyleObj: {
        height: "",
        width: "",
      },
      classlist:[],
      loading:false
    };
  },

  methods: {
    getHeight() {
      // 获取浏览器高度，减去顶部导航栏的值，70该值也可以动态获取

      this.contentStyleObj.height = window.innerHeight;

      this.contentStyleObj.width = window.innerWidth;
    },
    baoming(val){
       let tokens = sessionStorage.getItem("token");
    let token = JSON.parse(tokens);
    //  // console.log(this.classlist[val].id);
      if (token) {
        let phones = sessionStorage.getItem("phone");
         let phone = JSON.parse(phones);
        //  // console.log(phone);
        PostsignUpClass({
          phoneNum:phone,
          classid:this.classlist[val].id
        }, {
        "X-Nideshop-Token": token,
      }).then(res=>{
        //  // console.log(res);
        if (res.retCode=='00000000') {
          this.$message({
          message: '恭喜你,报名成功',
          type: 'success'
        });
        }else if(res.retCode=='E0000000'){
          this.$message({
          message: res.retMsg,
          type: 'warning'
        });
        }
         
      })
      }else{
          this.$message('请登录');
            this.loading=true
            setTimeout(() => {
               this.$router.push("/login");
            }, 2000);
      }
    }
  },

  created() {
    window.addEventListener("resize", this.getHeight);

    this.getHeight();
 let ids = sessionStorage.getItem("id");
    let id = JSON.parse(ids);
    //  // console.log(this.contentStyleObj);
    GetrecentlyClass({
      id:Number(id)
    }).then(res =>{
        //  // console.log(res);
      if (res.retCode=='00000000') {
        this.classlist=res.retMsg
      }
      //   // console.log(this.classlist);
    })
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
 
};
</script>

<style lang="less" scoped>
.box12 {
  width: 100%;
  min-height: 100vh;
  background-color: #edf1f6;
  overflow: hidden;
}
.register {
  background-color: #f5fafe;
}
.new_user {
  width: 551px;
  margin: 0 auto;
  margin-top: 67px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  text-align: left;
  h4 {
    font-size: 26px;
    margin-left: 96px;
    margin-bottom: 36px;
    padding-top: 30px;
    font-weight: 500;
  }
}
.demo-ruleForm {
  .el-input {
    display: inline-block;
    width: 340px;
  }
  span {
    color: red;
    margin-left: 15px;
  }
  .el-select {
    display: inline-block;
    width: 340px;
  }
  .el-button {
    width: 137px;
    height: 50px;
    margin-right: 55px;
    margin-bottom: 106px;
    margin-top: 32px;
  }
}
.SMS {
  margin-left: 15px;
  color: red;
}
.list {
  width: 1070px;
  margin: 0 auto;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 30px;
  background: #fff;
  padding-bottom: 25px;
  margin-bottom: 50px;
  .title {
    height: 41px;
    background: #3584e8;
    p {
      font-size: 18px;
      line-height: 41px;
      color: #fff;
      text-align: left;
      margin-left: 45px;
    }
  }
}
.baoming {
  position: relative;
  top: 75px;
  right: 0;
  width: 66px;
  height: 27px;
  font-size: 14px;
  line-height: 1px;
}
/deep/.el-descriptions__title {
  font-size: 18px;
}
/deep/ .el-descriptions__body {
  width: 500px;
  background: #f0f5f9;
}
/deep/ .el-descriptions__table {
  color: #089aed;
}
/deep/ .el-descriptions__table tbody:first-child {
  color: #9ea3a6;
}
.bjlb {
  width: 994px;
  // height: 127px;
  background: #f0f5f9;
  margin: 0 auto;
  margin-top: 19px;
  padding: 26px 24px 5px 37px;
  box-sizing: border-box;
}
/deep/ .starttime {
  color: #9ea3a6;
}
@media screen and(max-width:768px) {
  .list {
    width: 100%;
    .title {
      height: 32px;
      p {
        line-height: 32px;
        font-size: 16px;
        margin-left: 32px;
      }
    }
  }
  .bjlb {
    width: 100%;
  }
  /deep/.el-descriptions__header {
    display: initial;
  }
  .baoming {
    top: 105px;
    right: -125px;
  }
  /deep/.el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
    padding-bottom: 8px;
  }

  /deep/ .el-descriptions__table tbody:nth-child(2) {
    color: #9ea3a6;
  }
}
</style>
